const AUDIO_FILTERS = [
  'advancedNoiseSuppression',
];

export default audioFilter => AUDIO_FILTERS.includes(audioFilter?.type);
